<div class="modal-header">
  <h3>{{ title }}</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body h-100 d-flex flex-column">
  <div class="row">
    <div class="col">
      <ul class="vive-blue_list">
        <li>Click on any row to edit that vendor.</li>
        <li>
          Rows highlighted in <span class="yellow fw-semibold">YELLOW</span> are
          vendors matching existing vendors. ({{ duplicateVendorCount }})
        </li>
        <li>
          Rows highlighted in <span class="red fw-semibold">RED</span> are
          vendors with missing required fields. ({{
            missingRequiredFieldsCount
          }})
        </li>
        <li>
          Rows highlighted in <span class="pink fw-semibold">PINK</span> share
          the same tax id with another vendor in the list. ({{
            sharedTaxIdVendorCount
          }})
        </li>
      </ul>
    </div>
  </div>

  @if (
    selectedRows.length > 0 &&
    (CompanyComplianceTypes.length > 0 || ExemptVendorTypes.length > 0)
  ) {
    <div class="row mb-3 align-items-end">
      @if (CompanyComplianceTypes.length > 0) {
        <div class="col">
          <label class="form-label" for="bulk-company-compliance-type">
            Compliance program for selected vendors
          </label>
          <select
            id="bulk-company-compliance-type"
            class="form-select"
            [(ngModel)]="selectedCompanyComplianceType"
          >
            <option disabled [ngValue]="undefined">Pick one…</option>
            @for (item of CompanyComplianceTypes; track item.id) {
              <option [ngValue]="item">
                {{ item.type }}
              </option>
            }
          </select>
        </div>
      }

      @if (ExemptVendorTypes.length > 0) {
        <div class="col">
          <label class="form-label" for="bulk-company-compliance-type">
            Exempt vendor types for selected vendors
          </label>
          <select
            id="bulk-exempt-vendor-type"
            class="form-select"
            [(ngModel)]="selectedExemptVendorType"
          >
            <option disabled [ngValue]="undefined">Pick one…</option>
            @for (item of ExemptVendorTypes; track item.id) {
              <option [ngValue]="item">
                {{ item.type }}
              </option>
            }
          </select>
        </div>
      }

      <div class="col">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="
            !selectedCompanyComplianceType && !selectedExemptVendorType
          "
          (click)="applyDataToSelectedRows()"
          title="Apply the selected data to every selected vendor"
        >
          Apply to {{ selectedRows.length }} Selected Vendor{{
            selectedRows.length !== 1 ? 's' : ''
          }}
        </button>
      </div>
    </div>
  }

  @if (missingRequiredFieldsCount > 0 || duplicateVendorCount > 0) {
    <div class="row mb-2">
      <div class="col d-flex gap-2">
        @if (missingRequiredFieldsCount > 0) {
          <button
            type="button"
            class="btn btn-danger btn-sm"
            (click)="removeRedRows()"
            title="Remove all vendors missing required information"
          >
            Remove {{ missingRequiredFieldsCount }} Red Row{{
              missingRequiredFieldsCount !== 1 ? 's' : ''
            }}
          </button>
        }
        @if (duplicateVendorCount > 0) {
          <button
            type="button"
            class="btn btn-warning btn-sm"
            (click)="removeYellowRows()"
            title="Remove all duplicate vendors"
          >
            Remove {{ duplicateVendorCount }} Yellow Row{{
              duplicateVendorCount !== 1 ? 's' : ''
            }}
          </button>
        }
        @if (sharedTaxIdVendorCount > 0) {
          <button
            type="button"
            class="btn btn-pink btn-sm"
            (click)="removePinkRows()"
            title="Remove all vendors sharing a tax id with another vendor in the upload"
          >
            Remove {{ sharedTaxIdVendorCount }} Pink Row{{
              sharedTaxIdVendorCount !== 1 ? 's' : ''
            }}
          </button>
        }
      </div>
    </div>
  }

  <div class="row flex-grow-1" style="min-height: 400px">
    <div class="col">
      <app-company-vendors-grid
        [gridName]="'AdminExemptVendorUpload'"
        [rowModelType]="'clientSide'"
        [gridPrimaryKeyFieldName]="'rowId'"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [rowData]="rowData"
        [rowSelectionType]="'multiple'"
        [suppressFieldDotNotation]="false"
        [rowClassRules]="rowClassRules"
        (rowSelectionChanged)="rowSelectionChanged($event)"
        (actionEvent)="actionEvent($event)"
        [(reloadGridData)]="reloadGrid"
      ></app-company-vendors-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="col-2">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>

  <div class="col-2">
    <button type="button" class="btn btn-primary h-100" (click)="upload()">
      Upload
    </button>
  </div>
</div>
